import _ from "lodash";

import {
  Component,
} from "react";
import {
  Button,
} from "react-bootstrap";
import Markdown from "pagedown/Markdown.Sanitizer";

import {
  openWindow,
} from "CommonCore/util";
import {
  Awesome,
} from "CommonComponents/bricks";

export const converter = Markdown.getSanitizingConverter();

export class MarkdownPreview extends Component {
  render() {
    const {
      value,
      className,
      placeholder,
    } = this.props;
    const props = {
      dangerouslySetInnerHTML: value && { __html: converter.makeHtml(value) },
      children: !value && placeholder,
    };
    return <span
      {..._.pickBy(props, _.identity)}
      className={className}
    />;
  }
}

export class MarkdownEditor extends Component {
  render() {
    const {
      value,
      onChange,
      previewClassName,
    } = this.props;
    return <div>
      <textarea
        value={value}
        className='markdown-input'
        onChange={onChange}
      />
      <MarkdownPreview
        value={value}
        className={previewClassName}
        placeholder={<em className='text-muted'>Vorschau</em>}
      />
    </div>;
  }
}

export class MarkdownHelpButton extends Component {
  openHelp = async() => {
    const markdownHelp = await import("./markdown-help.html");
    openWindow("Markdown Hilfe", markdownHelp.default, "MarkdownHilfe");
  };

  render() {
    return <Button variant='link' onClick={this.openHelp}><Awesome name='question-circle'/></Button>;
  }
}
